import { ReactNode, createContext, useContext, useState } from "react";
import DeleteModal from "./DeleteModal";
import { IFaq } from "models/faq";

interface IFaqAlertProps {
  showDelete: (Faq: IFaq) => void;
}

export const FaqAlertContext = createContext<IFaqAlertProps>(
  {} as IFaqAlertProps
);

export const useFaqAlertContext = () =>
  useContext<IFaqAlertProps>(FaqAlertContext);

interface IOpen {
  open: boolean;
  faq: IFaq | null;
}

export function FaqAlertContextProvider({ children }: { children: ReactNode }) {
  const [openDelete, setOpenDelete] = useState<IOpen>({
    open: false,
    faq: null,
  });

  const showDelete = (faq: IFaq) => setOpenDelete({ open: true, faq });
  const handleCloseDelete = () => setOpenDelete({ open: false, faq: null });

  return (
    <FaqAlertContext.Provider
      value={{
        showDelete,
      }}
    >
      {openDelete.faq && (
        <DeleteModal
          open={openDelete.open}
          faq={openDelete.faq}
          handleClose={handleCloseDelete}
        />
      )}

      {children}
    </FaqAlertContext.Provider>
  );
}
